import { z } from 'zod';

/** 台灣統一發票號碼：2 碼大寫英文字軌＋8 碼數字，例：AB12345678 */
const TW_INVOICE_NO_PATTERN = /^[A-Z]{2}\d{8}$/;

/** 發票號碼正規化：轉大寫、去掉空白與「-」 */
export function normalizeInvoiceNo(value) {
  return String(value ?? '').toUpperCase().replace(/[\s-]/g, '');
}

export const voucherFormSchema = z.object({
  voucherType: z.enum(['INVOICE', 'RECEIPT'], { message: '請選擇憑證類型' }),
  voucherNo: z.string().trim().min(1, '請填寫憑證號碼'),
  voucherDate: z.string().min(1, '請填寫憑證日期'),
  totalAmount: z.union([z.string(), z.number()]).refine((value) => {
    const n = Number(value);
    return Number.isFinite(n) && n >= 0;
  }, { message: '總額不可為負' }),
  remark: z.string().optional().nullable(),
})
  // 收據沒有統一格式，只檢查發票
  .superRefine((values, ctx) => {
    if (values.voucherType !== 'INVOICE' || !values.voucherNo) {
      return;
    }
    if (!TW_INVOICE_NO_PATTERN.test(normalizeInvoiceNo(values.voucherNo))) {
      ctx.addIssue({
        code: 'custom',
        path: ['voucherNo'],
        message: '發票號碼須為 2 個英文字母＋8 位數字，例：AB12345678',
      });
    }
  })
  // 送出值用正規化後的發票號碼
  .transform((values) => (
    values.voucherType === 'INVOICE'
      ? { ...values, voucherNo: normalizeInvoiceNo(values.voucherNo) }
      : values
  ));

export const VOUCHER_FIELD_LABELS = {
  voucherType: '憑證類型',
  voucherNo: '憑證號碼',
  voucherDate: '憑證日期',
  totalAmount: '總額',
  remark: '備註',
};

export const VOUCHER_FORM_DEFAULTS = {
  voucherType: 'INVOICE',
  voucherNo: '',
  voucherDate: '',
  totalAmount: '',
  remark: '',
};
